import React, { useState, useEffect, useCallback } from "react";
import * as S from "./styles";
import * as API from "../../api";
import { toast } from "react-toastify";
import { Loading } from "../../components/Loading";
import { Sort } from "../../components/Sort";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {  faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { FieldList } from "../../components/FieldList/index";
import { FieldText } from "../../components/FieldText";
import { PartidaUsuario } from "../../components/PartidaUsuario";
import { Paginator } from "../../components/Paginator";
import { MOVIMIENTOS_POR_PAGINA } from "../../constants";

export const GlosarioPartidas = () => {
  const [loading, setLoading] = useState(true);
  const [areas, setAreas] = useState([]);
  const [selectedArea, setSelectedArea] = useState(null);
  const [familias, setFamilias] = useState([]);
  const [selectedFamilia, setSelectedFamilia] = useState(null);
  const [conceptos, setConceptos] = useState([]);
  const [selectedConcepto, setSelectedConcepto] = useState(null);
  const [partidas, setPartidas] = useState([]);
  const [selectedPartida, setSelectedPartida] = useState(null);
  const [nombrePartida, setNombrePartida] = useState(null);
  const [metadataTable, setMetadataTable] = useState([]);
  const [sortActive, setSortActive] = useState({});
  const [partidasPosrUsuario, setPartidasPosrUsuario] = useState([]);
  
  const [totalRegistros, setTotalRegistros] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [recordsByPage, setRecordsByPage] = useState(MOVIMIENTOS_POR_PAGINA);
  const [triggerGetMovimientos, setTriggerGetMovimientos] = useState(true);

  useEffect(() => {
    API.definicionPagina({ Modulo: "PartidaUsuario", TipoDefinicion: "grilla" })
        .then((res) => setMetadataTable(res))
        .catch((error) => API.DEVELOP && console.log(error));

    obtenerAreasPorUsuario();
    getPartidasUsuario({ pageIndex: 1, pageSize: MOVIMIENTOS_POR_PAGINA });
  }, []);

  useEffect(() => {
      if (triggerGetMovimientos) {
        getPartidasUsuario({ pageIndex: 1, pageSize: recordsByPage });
      }
    }, [triggerGetMovimientos]);
  

  const getPartidasUsuario = (paginacion) => {
    setLoading(true);
    const data = {
      idArea: selectedArea?.value === undefined ? null : selectedArea?.value,
      familia: selectedFamilia?.value === undefined ? null : selectedFamilia?.value, 
      concepto: selectedConcepto?.value === undefined ? null : selectedConcepto?.value,
      idPartida: selectedPartida?.value === undefined ? null : selectedPartida?.value,
      nombrePartida: nombrePartida,
      paginacion: {
        Pagina: paginacion.pageIndex,
        CantidadRegistros: paginacion.pageSize,
      }
    };

    API.ObtenerPartidasPorUsuario(data)
      .then((res) => {
        setPartidasPosrUsuario(res.items);
        setTotalRegistros(res.totalItems);
        setCurrentPage(res.pageIndex);
        setLastPage(res.totalPages);
        setRecordsByPage(paginacion.pageSize);
      })
      .catch((error) => {
        if (error.code !== 401)
          toast.error("Error al obtener partidas de usuario\n" + error.msg?.Message);
        API.DEVELOP && console.log(error);
      })
      .finally(() => {
        setTriggerGetMovimientos(false);
        setLoading(false)
      });
  };

  const handleAreaChange = (id, value) => {
    setSelectedArea({ value: value.Valor, label: value.Etiqueta });
  };

  const handleFamiliaChange = (id, value) => {
    setSelectedFamilia({ value: value.Valor, label: value.Etiqueta });
  };

  const handleConceptoChange = (id, value) => {
    setSelectedConcepto({ value: value.Valor, label: value.Etiqueta });
  };

  const handlePartidaChange = (id, value) => {
    setSelectedPartida({ value: value.Valor, label: value.Etiqueta });
  };

  const handleNombrePartidaChange = (id, value) => {
    setNombrePartida(value);
  };

  useEffect(() => {
   setFamilias([]);
   setSelectedFamilia(null);
   obtenerFamiliaPorArea();
  }, [selectedArea]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setConceptos([]);
    setSelectedConcepto(null);
    obtenerConceptosPorFamilia();
   }, [selectedFamilia]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setPartidas([]);
    setSelectedPartida(null);
    obtenerPartidasPorConcepto();
   }, [selectedConcepto]); // eslint-disable-line react-hooks/exhaustive-deps

  const obtenerAreasPorUsuario= () => {
    setLoading(true);
    API.obtenerAreasUsuario()
      .then((res) => {
        setAreas(res.map((e) => ({ value: e.Valor, label: e.Etiqueta })));
      })
      .catch((error) => {
        if (error.code !== 401)
          toast.error("Error al obtener Areas\n" + error.msg?.Message);
        API.DEVELOP && console.log(error);
      })
      .finally(() => setLoading(false));
  };

  const obtenerFamiliaPorArea = () => {
    if (selectedArea?.value === null || selectedArea?.value ===  undefined) return;
    setLoading(true);
    API.obtenerFamiliaPorArea(selectedArea.value)
      .then((res) => {
        setFamilias(res.map((e) => ({ value: e.Valor, label: e.Etiqueta })));
      })
      .catch((error) => {
        if (error.code !== 401)
          toast.error("Error al obtener Familias\n" + error.msg?.Message);
        API.DEVELOP && console.log(error);
      })
      .finally(() => setLoading(false));
  };

  const obtenerConceptosPorFamilia = () => {
    if (selectedFamilia?.value === null || selectedFamilia?.value === undefined  ||
      selectedArea?.value === null || selectedArea?.value === undefined) return;
    setLoading(true);
    const data ={ familia: selectedFamilia.value, idArea: selectedArea.value };
    API.obtenerConceptoPorFamilia(data)
      .then((res) => {
        setConceptos(res.map((e) => ({ value: e.Valor, label: e.Etiqueta })));
      })
      .catch((error) => {
        if (error.code !== 401)
          toast.error("Error al obtener Conceptos\n" + error.msg?.Message);
        API.DEVELOP && console.log(error);
      })
      .finally(() => setLoading(false));
  };

  const obtenerPartidasPorConcepto = () => {
    if (selectedFamilia?.value === null || selectedFamilia?.value === undefined || 
      selectedConcepto?.value === null || selectedConcepto?.value === undefined || 
      selectedFamilia?.value === null || selectedFamilia?.value === undefined) return;
    setLoading(true);
    const data ={ concepto: selectedConcepto.value, familia: selectedFamilia.value, idArea: selectedArea.value };
    API.ObtenerPartidasPorConcepto(data)
      .then((res) => {
        setPartidas(res.map((e) => ({ value: e.Valor, label: e.Etiqueta })));
      })
      .catch((error) => {
        if (error.code !== 401)
          toast.error("Error al obtener Partidas\n" + error.msg?.Message);
        API.DEVELOP && console.log(error);
      })
      .finally(() => setLoading(false));
  };

  const sort = (field, value) => {
    setSortActive({
      IdCampo: field,
      Orden: value,
    });
  };

  const filterPartidas = () => {
    getPartidasUsuario({ pageIndex: 1, pageSize: recordsByPage });
  };

  const onChangePagination = (data) => {
    getPartidasUsuario(data);
  }

  return (
    <S.Container>
      <Loading hidden={!loading} />
      <S.Filters count={6}>
        <FieldList
          id="areaSelect"
          type="enum"
          currentOption={selectedArea}
          canBeEmpty={true}
          options={areas}
          label="Area"
          handleChange={handleAreaChange}
        />

        <FieldList
          id="familiaSelect"
          type="enum"
          currentOption={selectedFamilia}
          canBeEmpty={true}
          options={familias}
          label="Familia"
          handleChange={handleFamiliaChange}
          isDisabled={selectedArea===null || selectedArea===undefined}
        />

        <FieldList
          id="conceptoSelect"
          type="enum"
          currentOption={selectedConcepto}
          canBeEmpty={true}
          options={conceptos}
          label="Concepto"
          handleChange={handleConceptoChange}
          isDisabled={selectedFamilia===null || selectedFamilia===undefined}
        />

        <FieldList
          id="partidaSelect"
          type="enum"
          currentOption={selectedPartida}
          canBeEmpty={true}
          options={partidas}
          label="Partida"
          handleChange={handlePartidaChange}
          isDisabled={selectedConcepto===null || selectedConcepto===undefined}
        />

        <FieldText
          id="nombrePartida"
          label="Nombre Partida"
          value={nombrePartida}
          readOnly={false}
          required={false}
          styles={"filter"}
          handleChange={handleNombrePartidaChange}
        />

        <S.Buttons>
          <button
            id="applyBtn"
            onClick={() => filterPartidas()}
          >
            <FontAwesomeIcon icon={faPlusCircle} size="lg" />
            Aplicar
          </button>
        </S.Buttons>
      </S.Filters>
      <span>{totalRegistros} Registros.</span>
      <S.Table>
        <S.ColGroup>
          {metadataTable.map((campo) => (
            <S.Col key={campo.id} />
          ))}
        </S.ColGroup>
        <S.Tr>
          {metadataTable.map((campo) => (
            <S.Th key={campo.id} title={campo.etiqueta}>
              <S.HeaderColumn>
                <span>{campo.etiqueta}</span>
                {campo.ordenable && (
                  <Sort
                    field={campo.nombreCampo}
                    sortActive={sortActive}
                    onClick={(value) => sort(campo.nombreCampo, value)}
                  />
                )}
              </S.HeaderColumn>
            </S.Th>
          ))}
        </S.Tr>
        {partidasPosrUsuario.map((partida) => (
          <PartidaUsuario
            key={partida.Id}
            metadataTable={metadataTable}
            partida={partida}
          />
        ))}
      </S.Table>
      <Paginator pagination={{ pageIndex: currentPage, totalPages: lastPage }} onChange={onChangePagination} />
    </S.Container>
  );
};
